var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"xxx",staticClass:"holder"},[_c('div',{staticClass:"bkg animated zoomIn",class:{show: _vm.imageReady},style:(("background-image: url(" + _vm.bkgUrl + "); background-position: " + _vm.position))})])}
var staticRenderFns = []

export { render, staticRenderFns }